/**
 * ValidationModal.jsx
 * Created by michaelbray on 4/26/18.
 */

import React from 'react';
import PropTypes from 'prop-types';
import Modal from 'react-modal';
import { toLower } from 'lodash';
import * as Icons from './icons/Icons';

const propTypes = {
    fields: PropTypes.array,
    isOpen: PropTypes.bool,
    title: PropTypes.string,
    action: PropTypes.string,
    actionPastTense: PropTypes.string,
    lastValidated: PropTypes.shape({
        user: PropTypes.string,
        date: PropTypes.string
    }),
    closeModal: PropTypes.func,
    validate: PropTypes.func
};

const defaultProps = {
    fields: [],
    isOpen: false,
    title: "I hereby certify that the following fields have been validated:",
    action: "Validate",
    actionPastTense: "validated"
};

export default class ValidationModal extends React.Component {
    componentWillMount() {
        Modal.setAppElement('body');
    }

    render() {
        const modalClassNames = {
            base: 'rec-modal-dialog-base',
            afterOpen: 'rec-modal-dialog-after-open-md',
            beforeClose: 'rec-modal-dialog-before-close'
        };

        const overlayClassNames = {
            base: 'rec-overlay-base',
            afterOpen: 'rec-overlay-after-open',
            beforeClose: 'rec-overlay-before-close'
        };

        return (
            <Modal
                role="complementary"
                isOpen={this.props.isOpen}
                className={modalClassNames}
                overlayClassName={overlayClassNames}
                onRequestClose={this.props.closeModal}
                contentLabel={`${this.props.action} Data`}>
                <div>
                    <div className="rec-modal-content-wrap">
                        <button className="rec-close-modal" onClick={this.props.closeModal}>
                            <Icons.IconClose />
                        </button>
                        <div className="rec-modal-title">
                            {this.props.title}
                        </div>
                        <ul>
                            {
                                this.props.fields.map((field, index) => (
                                    <li key={`${field}-${index}`}>{field}</li>
                                ))
                            }
                        </ul>
                    </div>
                    <div className="rec-modal-actions-wrap">
                        <div className="rec-validation-text">
                            <div><em>Last {toLower(this.props.actionPastTense)} by:</em></div>
                            <div><em>{this.props.lastValidated.user} - {this.props.lastValidated.date}</em></div>
                        </div>
                        <button
                            className="rec-button-primary"
                            onClick={this.props.validate}>
                            {this.props.action}
                        </button>
                    </div>
                </div>
            </Modal>
        );
    }
}

ValidationModal.propTypes = propTypes;
ValidationModal.defaultProps = defaultProps;
